/* unplugin-vue-components disabled */import script from "./Swyy.vue?vue&type=script&lang=ts&setup=true"
export * from "./Swyy.vue?vue&type=script&lang=ts&setup=true"

import "./Swyy.vue?vue&type=style&index=0&id=43217cd5&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43217cd5"]])

export default __exports__